import React from "react";
import DateTimeDisplay from "./DateTimeDisplay";
import { useCountdown } from "../../helpers/useCountDown";
import StartMinting from "./StartMinting";
import PresaleForm from "./PresaleForm";
import Congrats from "./Congrats";
import Minting from "./Minting";

const ExpiredNotice = () => {
  return <Minting />;
};

const ShowCounter = ({ month, days, hours, minutes, seconds }) => {
  return (
    <div className="bg-[#121127] p-5 mt-[350px] 2xl:mt-[350px] md:mr-32 m-12 mb-64 rounded-md 2xl:h-[500px] 2xl:w-[540px] h-[500px] text-center lg:h-[500px] lg:w-[540px]  z-10 flex flex-col justify-between">
      <div className="text-left md:text-center">
        {" "}
        <h1 className="text-transparent tracking-tight letter-spacing:-0.05em mb-5 mt-9 bg-clip-text md:px-10 font-bold pb-5 bg-gradient-to-r from-[#8926B6] to-[#EABCFF] sm:text-4xl text-2xl  md:leading-9 lg:text-left text-center sm:text-[26px] md:text-[40px] lg:text-[48px] ">
          Public Sale
        </h1>
        <p className="text-3xl lg:text-5xl font-bold mt-24 text-white tracking-tight letter-spacing:-0.05em lg:text-left text-center md:px-10 px-5">
          Coming Soon
        </p>
      </div>

      {/* <div className="show-counter mt-[-70px]">
        <div className="countdown-link">
          {" "}
          <DateTimeDisplay value={month} type={"Month"} isDanger={false} />
          <DateTimeDisplay value={days} type={"Days"} isDanger={false} />
          <DateTimeDisplay value={hours} type={"Hours"} isDanger={false} />
          <DateTimeDisplay value={minutes} type={"Mins"} isDanger={false} />
          <DateTimeDisplay value={seconds} type={"Seconds"} isDanger={false} />
        </div>
      </div> */}
      <div className="flex md:flex-row flex-col justify-between mb-9 mt-[-50px] px-[40px] 2xl:px-[50px]">
        <div className="md:w-5/12 w-full text-[#747397] text-left">
          <p className="text-[12px] letter-spacing:-0.05em mt-4 tracking-tight letter-spacing:-0.05em">
            Get the latest info on the Presale date and giveaways.
          </p>
        </div>
        <div className="relative mt-5 h-fill">
          <a
            href="https://discord.com/invite/ZCBgakG7Sv"
            className="md:px-5 md:py-2 text-lg md:text-[16px] lg:text-[18px] 2xl:text-[20px] 2xl:py-3 font-medium tracking-tight letter-spacing:-0.05em  px-2 py-3  text-white bg-[#646AFB] hover:bg-sky-700 rounded-md "
          >
            Join our Discord
          </a>
        </div>
      </div>
    </div>
  );
};

const CountdownTimer = ({ targetDate }) => {
  const [month, days, hours, minutes, seconds] = useCountdown(
    "Sun May 1 2023 00:00:00 GMT+0200 (Central Africa Time)"
  );

  if (month + days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />;
  } else {
    return (
      <ShowCounter
        month={month}
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

export default CountdownTimer;
